<template>
  <v-select
    :data-testid="dataTestid" v-bind="$attrs" v-on="$listeners" :items="types" item-value="id" />
</template>

<script>
import { typeDocument } from "@/filters/typedocument";
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    typesDocuments: {
      type: String,
      required: false,
    },
     avecObservations: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    typesDoc() {
      if(this.avecObservations) {
        return ["OBSERVATIONS"];
      }

      if ("rattachement" === this.typesDocuments) {
        return ["PIECE_ETAT_CIVIL", "PIECE_JOINTE"];
      }

      // on veut tous les documents pour le type pieces
      if ("pieces" === this.typesDocuments) {
        return [
          "DECLARATION_INSCR",
          "PV_AG",
          "STATUTS",
          "TITRE_CONSTITION_DIRECTION",
          "DECISION_DIRECTION",
          "JUSTIFICATIF_PAIEMENT",
          "EXTRAIT_PUB_JAL",
          "TRAITE_APPORT",
          "DECISION_JUDICIAIRE",
          "AVIS_MINISTERE_PUBLIC",
          "PIECE_ETAT_CIVIL",
          "PIECE_JOINTE",
        ];
      }
      //quand pas de type, il s'agit des documents pour une création
      return [
        "DECLARATION_INSCR",
        "PV_AG",
        "STATUTS",
        "TITRE_CONSTITION_DIRECTION",
        "PIECE_ETAT_CIVIL",
        "PIECE_JOINTE",
      ];
    },
    types() {
      return this.typesDoc.map(id => ({
        id,
        text: typeDocument(id),
      }));
    },
  },
};
</script>
